export const getDefault = () => {
  const schema = {
    name: 'SubWebWarnings',
    title: 'Avisos',
    hasLink: false,
    tabs: [
      {
        id: 1,
        text: 'categoria 1'
      },
      {
        id: 2,
        text: 'categoria 2'
      }
    ],
    data: [
      {
        id: 1,
        list: [
          {
            title: 'Licenciatura em Lorem ipsum',
            subTitle: 'Lorem ipsum dolor sit amet.',
            text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium consectetur corporis culpa deleniti dolor fficia optio quam quasi qui sapiente sint tenetur voluptatem [voluptatibus](https://www.ua.pt)...<br/>\n\n\n'
          },
          {
            title: 'Licenciatura em Lorem ipsum',
            subTitle: 'Lorem ipsum dolor sit amet.',
            text:
              'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium consectetur corporis culpa deleniti dolor fficia optio quam quasi qui sapiente sint tenetur voluptatem voluptatibus...'
          },
          {
            title: 'Licenciatura em Lorem ipsum',
            subTitle: 'Lorem ipsum dolor sit amet.',
            text:
              'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium consectetur corporis culpa deleniti dolor fficia optio quam quasi qui sapiente sint tenetur voluptatem voluptatibus...'
          }
        ]
      },
      {
        id: 2,
        list: [
          {
            title: 'Licenciatura em economia',
            subTitle: 'economia dolor sit amet.',
            text:
            'economia dolor sit amet, consectetur adipisicing elit. Accusantium consectetur corporis culpa deleniti dolor fficia optio quam quasi qui sapiente sint tenetur voluptatem voluptatibus...'
          },
          {
            title: 'Licenciatura em economia2',
            subTitle: 'economia dolor sit amet.',
            text:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium consectetur corporis culpa deleniti dolor fficia optio quam quasi qui sapiente sint tenetur voluptatem voluptatibus...'
          },
          {
            title: 'L3',
            subTitle: 'Lorem ipsum dolor sit amet.',
            text:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium consectetur corporis culpa deleniti dolor fficia optio quam quasi qui sapiente sint tenetur voluptatem voluptatibus...'
          }
        ]
      }
    ]
  }
  return schema
}
